import type { CountertopRun, CountertopSection } from '../types';

export type GetCountertopSectionsParams = {
	run: CountertopRun;
	centers: Array<number>;
};

/**
 * Splits a run into the stretches of countertop between its edges and each breakpoint.
 * Centres outside the run, and duplicates, are ignored -- a seam cannot divide what it misses.
 * @param params run extents and the breakpoint centres dividing it
 * @returns sections ordered left to right; a run with no breakpoints yields one section
 */
export const getCountertopSections = (params: GetCountertopSectionsParams): Array<CountertopSection> => {
	const { run, centers } = params;
	const { left, right } = run;

	const inside = Array.from(new Set(centers.filter((center) => center > left && center < right))).sort((a, b) => a - b);
	const bounds = [left, ...inside, right];

	return bounds.slice(0, -1).map((start, index) => {
		const end = bounds[index + 1];
		return { start, end, length: end - start };
	});
};
